import { Wifi } from 'lucide-react';

import { Card } from '@/components/ui/card';

/**
 * Covers the call while livekit-client retries. Frozen tiles read as a crash;
 * an honest "we are getting you back in" reads as a blip, which is what a
 * 4G-to-Wi-Fi handover actually is.
 */
export function ReconnectOverlay({ visible }: { visible: boolean }) {
  if (!visible) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="overlay animate-in fade-in-0 fixed inset-0 z-50 grid place-items-center bg-black/75 p-6 backdrop-blur-md duration-200"
    >
      <Card className="animate-in zoom-in-95 flex max-w-sm flex-col items-center p-8 text-center duration-300">
        <span className="relative grid size-14 place-items-center">
          {/* Two offset rings rather than a spinner: it reads as "signal
              searching" instead of "page loading". */}
          <span className="border-primary/30 absolute inset-0 animate-ping rounded-full border-2 motion-reduce:animate-none" />
          <span className="border-primary/25 bg-primary/10 absolute inset-0 rounded-full border" />
          <Wifi className="text-primary size-6" strokeWidth={2.25} />
        </span>

        <h2 className="mt-5 text-lg font-semibold tracking-tight">Reconnecting…</h2>
        <p className="text-muted-foreground mt-2 text-sm text-pretty">
          Your connection dropped. We are getting you back in — this usually takes a few seconds, and
          the other person can still see you rejoin.
        </p>
      </Card>
    </div>
  );
}
